"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getIsRestoring = exports.getIsConnected = exports.createCurrentUserSelectors = exports.createEntitiesSelectors = void 0;
const createEntitiesSelectors_1 = __importDefault(require("./createEntitiesSelectors"));
exports.createEntitiesSelectors = createEntitiesSelectors_1.default;
const createCurrentUserSelectors_1 = __importDefault(require("./createCurrentUserSelectors"));
exports.createCurrentUserSelectors = createCurrentUserSelectors_1.default;
// subscriptions & queries
const getIsConnected = (state) => !!state.ddp.status && state.ddp.status.connected;
exports.getIsConnected = getIsConnected;
const getIsRestoring = (state) => !!state.ddp.status && state.ddp.status.restoring;
exports.getIsRestoring = getIsRestoring;
//# sourceMappingURL=index.js.map